import type { LayerDefinition } from '../project/model';
import type { JoinConfig, JoinId } from './model';
import { joinDependencies, type JoinDependencyArea } from './dependencies';

export type JoinDependencySummaryArea = 'Display Filter' | 'Labels' | 'Popups' | 'Style';

export interface JoinRemovalPlan {
  readonly dependencies: readonly JoinDependencyArea[];
  readonly join: JoinConfig;
  readonly layer: LayerDefinition;
  readonly summaryAreas: readonly JoinDependencySummaryArea[];
}

export function summarizeJoinDependencies(
  dependencies: readonly JoinDependencyArea[],
): readonly JoinDependencySummaryArea[] {
  const areas: JoinDependencySummaryArea[] = [];
  if (dependencies.includes('Style')) areas.push('Style');
  if (dependencies.includes('Popup fields') || dependencies.includes('Popup title')) {
    areas.push('Popups');
  }
  if (dependencies.includes('Label field') || dependencies.includes('Label filter')) {
    areas.push('Labels');
  }
  if (dependencies.includes('Display filter')) areas.push('Display Filter');
  return areas;
}

export function planJoinRemoval(layer: LayerDefinition, joinId: JoinId): JoinRemovalPlan | null {
  const join = (layer.joins ?? []).find((candidate) => candidate.id === joinId);
  if (!join) return null;
  const outputFields = join.fields.map((field) => field.outputFieldId);
  const dependencies = joinDependencies(layer, outputFields);
  const nextLayer: LayerDefinition = {
    ...layer,
    joins: (layer.joins ?? []).filter((candidate) => candidate.id !== joinId),
  };
  return {
    dependencies,
    join,
    layer: nextLayer,
    summaryAreas: summarizeJoinDependencies(dependencies),
  };
}
